import React from "react";
import { Sidebar } from "../Sidebar/Sidebar";
import "./Layout.css";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="layout">
      <Sidebar />
      <main className="layout__main">{children}</main>
    </div>
  );
};
